import ca from './ca.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import hu from './hu.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import pt from './pt.json';
import ru from './ru.json';
import zh from './zh.json';

// ALL Translations from English using AI

export const languages = [
  {
    key: 'en-US',
    description: 'English',
    translation: en,
  },
  {
    key: 'es',
    description: 'Espanol',
    translation: es,
  },
  {
    key: 'ko',
    description: '한국어',
    translation: ko,
  },
  {
    key: 'en',
    description: 'English',
    translation: en,
  },
  {
    key: 'ca',
    description: 'Catalan',
    translation: ca,
  },
  {
    key: 'de',
    description: 'Deutsch',
    translation: de,
  },
  {
    key: 'fr',
    description: 'Français',
    translation: fr,
  },
  {
    key: 'it',
    description: 'Italiano',
    translation: it,
  },
  {
    key: 'pt',
    description: 'Português',
    translation: pt,
  },
  {
    key: 'ru',
    description: 'Русский',
    translation: ru,
  },
  {
    key: 'zh',
    description: '中文',
    translation: zh,
  },
  {
    key: 'ja',
    description: '日本語',
    translation: ja,
  },
  {
    key: 'hu',
    description: 'Magyar',
    translation: hu,
  },
];
